module.exports = __webpack_public_path__ + "static/media/bg4-autumn.e1e1688b.png";